var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Error 404")]),_c('p',[_vm._v("Página no encontrada")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Volver al Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }